import React from 'react'
import ActiveWorkshopList from '../../Components/StudentComponents/ActiveWorkshopList/ActiveWorkshopList'
import StudentDash from '../../Components/StudentComponents/StudentDash/StudentDash'

function WorkshopListPageS() {
  return (
    <StudentDash>
        <ActiveWorkshopList/>
    </StudentDash>
  )
}

export default WorkshopListPageS